import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import times from 'lodash/times';
import qs from 'qs';

import SubList from 'components/SubList';
import SearchSubsForm from 'components/SearchSubsForm';
import FormError from '../../FormError';

class SimoActivationRenewal extends Component {
  state = {
    selected: [],
    wasSearch: false,
    loading: false,
    renewalError: '',
    renewalSuccess: false,
  };

  componentDidMount() {
    const { location } = this.props;
    const { user_profile } = location
      ? qs.parse(location.search, { ignoreQueryPrefix: true })
      : '';

    if (user_profile) {
      this.handleSearchSubs({ user_profile });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.page !== this.props.page) {
      this.setState({
        selected: [],
        allCheckbox: false,
        renewalError: '',
        renewalSuccess: false,
      });
    }
  }

  handleCheckboxClick = (id) => {
    const { selected } = this.state;

    if (selected.includes(id)) {
      this.setState({
        selected: selected.filter((selectedId) => selectedId !== id),
      });
    } else {
      this.setState({
        selected: [...selected, id],
      });
    }
  };

  handleSelectAll = () => {
    const { subs } = this.props;
    const allSelected = subs.map((sub) => sub.id);

    this.setState({ selected: allSelected });
  };

  handleSearchSubs = (values) => {
    const { location, history, searchSubs, page } = this.props;
    const { user_profile } = location
      ? qs.parse(location.search, { ignoreQueryPrefix: true })
      : '';

    this.setState({
      selected: [],
      renewalError: '',
      renewalSuccess: false,
    });

    if (user_profile !== values.user_profile) {
      history.push({
        search: `?user_profile=${values.user_profile || ''}`,
      });
    }

    return searchSubs(page, {
      cycle_type: 'activation',
      simo_status: 'active,suspended',
      renewal_enabled: true,
      ...values,
    })
      .then(() => {
        this.setState({
          wasSearch: true,
        });
      })
      .catch((e) => console.log(e));
  };

  generateRenewalPurchase = () => {
    const { generateSimoRenewalPurchases } = this.props;
    const { selected } = this.state;

    if (selected.length === 0) {
      this.setState({
        renewalError: 'Select at least one subscription',
      });
      return;
    }

    this.setState({
      renewalError: '',
      renewalSuccess: false,
      loading: true,
    });

    generateSimoRenewalPurchases(selected)
      .then(() => {
        this.setState({
          renewalSuccess: true,
          loading: false,
        });
      })
      .catch((error) =>
        this.setState({
          renewalError: error.errors ? error.errors : error,
          loading: false,
        }),
      );
  };

  render() {
    const {
      subs,
      pageCount,
      page,
      pageRoute,
      subscriptionRoute,
      location,
      isSprintSubsSearch = false,
    } = this.props;
    const { selected, wasSearch, renewalError, renewalSuccess } = this.state;
    const { user_profile } = location
      ? qs.parse(location.search, { ignoreQueryPrefix: true })
      : '';

    const initialValues = { user_profile };

    return (
      <div className="tracfone-search">
        <h1>Generate Simo Activation Renewal Invoice</h1>
        <SearchSubsForm
          initialValues={initialValues}
          isSprintSubsSearch={isSprintSubsSearch}
          onSubmit={this.handleSearchSubs}
        />
        <br />
        {subs && subs.length > 0 && (
          <div className="renewal">
            <div className="renewal-button">
              {renewalSuccess && <span className="text-success">Saved.</span>}
              <button
                className="btn btn-default mar-r"
                onClick={this.handleSelectAll}
              >
                Select All
              </button>
              <button
                className="btn btn-primary"
                onClick={this.generateRenewalPurchase}
              >
                Generate Renewal Invoice
              </button>
            </div>
            {renewalError && <FormError error={renewalError} />}
          </div>
        )}
        {wasSearch && subs && subs.length > 0 && (
          <SubList
            subs={subs}
            viewUrl={subscriptionRoute}
            selectedSubs={selected}
            onCheckboxChange={this.handleCheckboxClick}
            showCheckbox
            isSimo
          />
        )}
        {subs && subs.length === 0 && <div>No results</div>}
        <nav aria-label="Page navigation">
          <ul className="pagination">
            {pageCount > 1 &&
              times(pageCount, (pageNum) => {
                pageNum += 1;
                return (
                  <li
                    key={pageNum}
                    className={pageNum === parseInt(page, 10) ? 'active' : ''}
                  >
                    <Link to={pageRoute(pageNum)}>{pageNum}</Link>
                  </li>
                );
              })}
          </ul>
        </nav>
      </div>
    );
  }
}

export default SimoActivationRenewal;
